import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {GetFleckviehMatingBullsAction, matingAction} from '../action';

const tableId = 'matingFleckviehBulls';

function* execute({payload: {tableDataRequest}}: GetFleckviehMatingBullsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getMaleFleckviehAnimalsInList,
        successAction: matingAction.getMaleFleckviehAnimalsSuccess,
        tableId,
    }));
}

/** Saga that handles `mating/GET_MATING_FLECKVIEH_BULLS`. */
export function* getMatingFleckviehBullsSaga(): SagaIterator {
    yield takeLatestF('mating/GET_FLECKVIEH_MATING_BULLS', execute);
}
